import { SvgIcon, SvgIconProps } from '@mui/material';
import styles from './WarningIcon.module.scss';

const WarningIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24" fontSize={props.fontSize || 'small'}>
    {/*  Triangle */}
    <path d="M1 21h22L12 2 1 21z" className={styles.backgroundIcon} />
    {/*  Exclamation mark */}
    <path
      d="M13 16h-2v2h2v-2zm0-8h-2v6h2V8z"
      className={styles.foregroundIcon}
    />
  </SvgIcon>
);

export default WarningIcon;
